import {
  Button,
  Center,
  Flex,
  Heading,
  Skeleton,
  Text,
  Box,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { Error, Layout } from "../../../components";
import { useIsAuth } from "../../../hooks/useIsAuth";
import { RootState } from "../../app/mainReducer";
import { useEffect } from "react";
import { cargaActions } from "../reducer";
import { Carga } from "../components";
import { Carga as CargaType, CargaItem } from "../types";
import { InfoSemCarga } from "../components";
import config from "../../../utils/config";

const CargaListFinalizadas = () => {
  useIsAuth();
  const isLoading = useSelector((state: RootState) => state.carga.isLoading);
  const cargas = useSelector((state: RootState) => state.carga.cargasFinalizadas || []);
  const pagination = useSelector((state: RootState) => state.carga.cargasFinalizadasPagination);
  const currentPage = pagination?.page || 1;
  const lastPage = pagination?.lastPage || 1;
  const error = useSelector((state: RootState) => state.carga.error || "");
  const networkOnline = useSelector(
    (state: RootState) => state.login.networkOnline || false
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (networkOnline) {
      dispatch(cargaActions.cargasFinalizadasRequest({ page: 1 }));
    }
  }, [dispatch, networkOnline]);

  const loadMore = () => {
    if (networkOnline && currentPage < lastPage && !isLoading) {
      dispatch(cargaActions.cargasFinalizadasRequest({ page: currentPage + 1 }));
    }
  };

  const hasMore = currentPage < lastPage;
  const remainingPages = lastPage - currentPage;

  const getCargasAgrupadasPorN01 = (): CargaType[] => {
    const cargasFiltradas = cargas.filter((carga) => !!carga.n01_ukey);
    const cargasAgrupadas: { [key: string]: CargaType[] } = {};

    cargasFiltradas.forEach(carga => {
      const n01Key = carga.n01_ukey;
      if (!cargasAgrupadas[n01Key]) {
        cargasAgrupadas[n01Key] = [];
      }
      cargasAgrupadas[n01Key].push(carga);
    });

    return Object.values(cargasAgrupadas).map(grupo => {
      let itens: CargaItem[] = [];

      let agrupamentos: string[] = [];

      for (const carga of grupo) {
        for (const item of carga.itens) {
          itens.push(item);
        }

        if (!agrupamentos.includes(carga.numero)) {
          agrupamentos.push(carga.numero);
        }
      }

      return {
        ...grupo[0],
        qt_pedidos: String(grupo.reduce((prev, curr) => {
          return prev + parseInt(curr.qt_pedidos); 
        }, 0)),
        itens,
        _agrupamento_numeros: agrupamentos.join(', '),
      }
    });
  };

  const buscarCargas = () => {
    if (config.agrupaCargasPeloAgrupamento) {
      return getCargasAgrupadasPorN01();
    }

    return cargas;
  };

  return (
    <Layout canLogout={true} isLoading={isLoading}>
      <Center mt={4}>
        <Heading>Cargas Finalizadas</Heading>
      </Center>
      <Center mb={2}>
        <Heading size="sm">Histórico de entregas realizadas</Heading>
      </Center>
      <Error error={error} />
      {!networkOnline && (
        <Box px={4} mt={4} mb={4}>
          <Alert status="warning" borderRadius="md">
            <AlertIcon />
            Você está sem internet. Conecte-se para visualizar as cargas finalizadas.
          </Alert>
        </Box>
      )}
      {networkOnline && !isLoading && buscarCargas().length === 0 && <InfoSemCarga />}
      {networkOnline &&
        buscarCargas().map((carga: CargaType) => (
          <div key={carga.j14_ukey}>
            <Carga carga={carga} />
          </div>
        ))}
      {networkOnline && hasMore && !isLoading && (
        <Flex direction="column" align="center" mt={4} mb={4} gap={2}>
          <Button
            colorScheme="teal"
            onClick={loadMore}
            size="lg"
          >
            Carregar mais
          </Button>
          <Text fontSize="sm" color="gray.600">
            {remainingPages === 1 
              ? '1 página restante' 
              : `${remainingPages} páginas restantes`} (página {currentPage} de {lastPage})
          </Text>
        </Flex>
      )}
      {networkOnline && !hasMore && cargas.length > 0 && !isLoading && (
        <Center mt={4} mb={4}>
          <Heading size="sm" color="gray.500">
            Todas as cargas foram carregadas
          </Heading>
        </Center>
      )}
    </Layout>
  );
};

export default CargaListFinalizadas;

